/* This is a simple representation of the three.js Vector3 class */
import {
  GetAllModuleBlueprints_allBlueprints_xAttachmentPoints_orientation,
} from '@src/app/generated/GetAllModuleBlueprints';
import { Vec3Input } from '@src/app/generated/globalTypes';
import { Vector3 } from 'three';

export class PortalVector3 extends Vector3 {
  constructor(x?: number, y?: number, z?: number) {
    super(x, y, z);
  };

  static fromGql(gql: GetAllModuleBlueprints_allBlueprints_xAttachmentPoints_orientation): PortalVector3 {
    return new PortalVector3(
      gql.x,
      gql.y,
      gql.z
    );
  }

  static fromThree(input: Vector3): PortalVector3 {
    if (input && input['x'] !== undefined && input['y'] !== undefined && input['z'] !== undefined) {
      return new PortalVector3(
        input.x,
        input.y,
        input.z
      );
    } else {
      return new PortalVector3(0, 0, 0);
    }
  }

  toGqlInput(): Vec3Input {
    return {
      x: this.x ?? 0,
      y: this.y ?? 0,
      z: this.z ?? 0,
    };
  }
}
